import { useRef, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import imagesLoaded from 'imagesloaded';

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

import styles from './FlagSection.module.scss';

import Logo from 'assets/images/tommyXTimberlandLogo.svg';

const FlagSection = ({t}) => {
	const wrapper = useRef(null);
	const flagbacktext = useRef(null);
	const tl2 = gsap.timeline();

	useEffect(() => {
		imagesLoaded(document.querySelectorAll('img'), {background: true}, () => {
			gsap.registerPlugin(ScrollTrigger);
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: wrapper.current,
					start: "top bottom",
					end: "bottom top",
					scrub: 0.3,
			    onUpdate: self => {
			    }
				}
			});

			tl.fromTo(flagbacktext.current, {
				x: '0vw'
			}, {
				x: '-100vw'
			}, 0);
			ScrollTrigger.refresh();

			tl2.to(flagbacktext.current, {
				x: -1000,
				duration: 20,
				repeat: -1,
				ease:'linear'
			})
		});
	}, []);

	return (

		<div className={styles.wrap} ref={wrapper}>
			<div className={styles.textSpacer}>
				<h1 ref={flagbacktext}>TOMMYXTIMBERLANDTOMMYXTIMBERLANDTOMMYXTIMBERLANDTOMMYXTIMBERLANDTOMMYXTIMBERLANDTOMMYXTIMBERLAND</h1>
			</div>
			<div className={styles.FlagSec}>
				<div className={styles.FlagSec_content}>
					<img src={Logo} />
					<p dangerouslySetInnerHTML={{__html:t('drop2_module2_sub')}} />
				</div>
			</div>
		</div>
	)
}

export default withTranslation()(FlagSection);